import React, { useState } from "react"

import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';

import dClasses from "./Dashboard.module.css";

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
// import {Link} from "react-router-dom";

import { useHistory } from "react-router-dom";
import Footer from "../Footer/Footer";

const useStyles = makeStyles((theme) => ({
    root: {
        // padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        // width: 350,
        background: 'rgb(12,12,12)',
        // borderRadius: '60px',
        color: '#fff'
    },
    input: {
        marginLeft: theme.spacing(3),
        flex: 1,
        color: '#fff'
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
        backgroundColor: '#fff'
    },
}));

const Dashboard = () => {

    const history = useHistory();

    const [ name, setName ] = useState("")

    const classes = useStyles();

    const validateName = (e) => {
        e.preventDefault()
        if (name !== "")
            history.push({
                pathname: '/call/'+name
                // state: { name: name }
            })
    }

    return(
        <div>

            <div className={dClasses.Banner}>

                <img className={dClasses.LandingImage} src="landingphoto.svg" alt="landing"/>

                <div className={dClasses.Text}>
                    <h1>Fast, reliable, and secure video conferencing for everyone.</h1>
                    <p>User-friendly and designed for high-quality, secure meetings, Summit is available on any device and is accessible to everyone.</p>

                    <div className={dClasses.InputName}>
                        <form onSubmit={(event) => validateName(event)}>
                            <Paper className={classes.root}>
                                <InputBase
                                    className={classes.input}
                                    placeholder="Enter your name"
                                    inputProps={{ 'aria-label': 'Enter your name' }}
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />

                                <Divider className={classes.divider} orientation="vertical" />

                                {/*<Link to={'/call/'+name}>*/}
                                <IconButton type='submit' style={{ color: "#fff" }} aria-label="call" >
                                    <ChevronRightRoundedIcon className={dClasses.MainActionBtn} />
                                </IconButton>
                                {/*</Link>*/}
                            </Paper>
                        </form>
                    </div>
                </div>

            </div>

            <div className={[dClasses.Banner, dClasses.BannerDivider].join(' ')}>

                <img src="demo1.png" alt="landing"/>

                <div className={dClasses.Text}>
                    <h1>Conference safely</h1>
                    <p>Summit protects your privacy and secures your data. Summit video calls are encrypted in transit, and our security features are updated on a regular basis for extra security.</p>
                </div>

            </div>

            <div className={[dClasses.Banner2].join(' ')}>

                <img src="demo2.png" alt="landing"/>

                <div className={dClasses.Text2}>
                    <h1>Talk from anywhere</h1>
                    <p>Effortlessly deliver professional client meetings whether you’re in the office, at home or on the road.</p>
                </div>

            </div>

            <div className={[dClasses.Banner].join(' ')}>

                <img src="demo3.png" alt="landing"/>

                <div className={dClasses.Text}>
                    <h1>Meet classy</h1>
                    <p>Keep things professional with this easy-to-use solution for your hard sell. With face-to-face video conferences, building stronger relationships can happen anywhere.</p>
                </div>

            </div>

            <div className={[dClasses.Banner2].join(' ')}>

                <img src="demo2.png" alt="landing"/>

                <div className={dClasses.Text2}>
                    <h1>Experience noise reduction</h1>
                    <p>Reduce distractions and interruptions with advanced noise removal and speech enhancement.</p>
                </div>

            </div>

            <Footer />

        </div>
    )
}

export default Dashboard;